export default __webpack_public_path__ + "static/media/png-grey.bd89a10f.svg";